import { Button, Modal } from '@warp-ds/react';
import { useState } from 'react';
import { makeSuggestion } from '../../../../api/suggestShipping';
import usePulse from '../../../../hooks/usePulse';
import { useSidebarContext } from '../../../../state/SidebarContext';
import { ConfirmationModalType, SuggestShippingType } from '../../../../types/uiTypes';
import ErrorModal from './ErrorModal';

type Props = {
    isOpen: boolean;
    close: () => void;
    uiText: ConfirmationModalType;
    handleConfirm: (res: SuggestShippingType) => void;
};

/**
 * This component renders the confirmation modal for suggest shipping (Be om Fiks ferdig).
 * It is also resposible for giving loading and error feedback in case the API-call fails.
 */
const ConfirmationModal = ({ isOpen, close, uiText, handleConfirm }: Props) => {
    const { finnkode, apiEndpoint } = useSidebarContext();
    const { trackConfirmSuggestShipping } = usePulse();

    const [isFetching, setIsFetching] = useState(false);
    const [hasError, setHasError] = useState(false);

    const onConfirm = async () => {
        setIsFetching(true);
        trackConfirmSuggestShipping();

        await makeSuggestion(finnkode, apiEndpoint)
            .then((res) => {
                if (!res?.sections.sidebar.suggestShipping) throw new Error();
                const newUI = res.sections.sidebar.suggestShipping;
                handleConfirm(newUI);
            })
            .catch(() => {
                setHasError(true);
            });
    };

    const onClose = () => {
        setIsFetching(false);
        if (hasError) setHasError(false);
        close();
    };

    if (hasError) {
        return <ErrorModal isOpen={isOpen} close={onClose} uiText={uiText} />;
    }

    return (
        <Modal
            open={isOpen}
            title={uiText.title}
            onDismiss={() => {
                onClose();
            }}
            footer={
                <div className="flex space-x-12">
                    <Button onClick={onClose} className="border-0">
                        {uiText.actions.abort.text}
                    </Button>
                    <Button primary onClick={onConfirm} loading={isFetching}>
                        {uiText.actions.confirm.text}
                    </Button>
                </div>
            }
        >
            <p>{uiText.text}</p>
        </Modal>
    );
};
export default ConfirmationModal;
